import { RenderIf, XButton } from '../index';
import Tooltip from '../ui-control/Tooltip';
import getUndoRedoButtonState from './undoRedoButtonState';

const inlineSpinnerClasses =
    "inline-block align-[-0.125em] animate-spin h-4 w-4 " +
    "border-2 border-current border-t-transparent rounded-full mr-1";

const UndoRedoButtons = ({
    hasUndo,
    hasRedo,
    handleUndo,
    isUndoLoading,
    isSuggestedEditRunning,
    isManualEditProcessing,
    disabled,
    className,
    variant
}) => {

    const { isUndoRedoLoading, undoTooltip, redoTooltip } = getUndoRedoButtonState({
        isUndoLoading,
        isSuggestedEditRunning,
        isManualEditProcessing
    });
    const isDisabled = isUndoRedoLoading || disabled;

    return (
        <>
            <RenderIf shouldRender={hasUndo}>
                <Tooltip title={undoTooltip} placement="bottom" leaveDelay={50}>
                    <XButton
                        variant={variant}
                        className={className}
                        onClick={() => { handleUndo(false) }}
                        disabled={isDisabled}
                        title={undoTooltip}
                    >
                        <RenderIf shouldRender={isUndoRedoLoading}>
                            <span className={inlineSpinnerClasses} role="status" />
                        </RenderIf>
                        <RenderIf shouldRender={!isUndoRedoLoading}>
                            <i className="fa fa-undo" />
                        </RenderIf>
                    </XButton>
                </Tooltip>
            </RenderIf>
            <RenderIf shouldRender={hasRedo}>
                <Tooltip title={redoTooltip} placement="bottom" leaveDelay={50}>
                    <XButton
                        variant={variant}
                        className={className}
                        onClick={() => { handleUndo(true) }}
                        disabled={isDisabled}
                        title={redoTooltip}
                    >
                        <RenderIf shouldRender={isUndoRedoLoading}>
                            <span className={inlineSpinnerClasses} role="status" />
                        </RenderIf>
                        <RenderIf shouldRender={!isUndoRedoLoading}>
                            <i className="fa fa-redo" />
                        </RenderIf>
                    </XButton>
                </Tooltip>
            </RenderIf>
        </>
    )
}

export default UndoRedoButtons;
